<template>
  <el-dialog
    class="dialog-container"
    :visible.sync="dialog"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="cancel"
    title="修改信息"
    center>
    <div class="flex flex-direction padding">
      <el-form class="ruleForm" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="auto">
        <el-form-item prop="organ_name" label="机构名称">
          <el-input v-model="ruleForm.organ_name" placeholder="请输入机构名称">
          </el-input>
       </el-form-item>
        <el-form-item label="登录账号">
          <el-input v-model="ruleForm.username" placeholder="请输入登录账号，为空则不修改">
          </el-input>
        </el-form-item>
        <el-form-item label="登录密码">
          <el-input v-model="ruleForm.password" placeholder="请输入登录密码，为空则不修改">
          </el-input>
        </el-form-item>
        <el-form-item label="手机号码">
          <el-input v-model="ruleForm.phone" placeholder="请输入手机号码，为空则不修改">
          </el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-operate flex align-center justify-center">
        <el-button class="btn min round" type="info" @click="cancel">取消</el-button>
        <el-button class="btn min round" type="primary" @click="submitForm('ruleForm')">
          确定
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>

import {updateOrganInfo} from "@/api/admin";

export default {
  name: "editOrgDialog",
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    row: {
      type: [String,Object],
      default: ''
    },
  },
  data() {
    return {
      options:[],
      ruleForm: {
        organ_name: '',
        username: '',
        password:'',
        phone:'',
      },
      rules: {
        organ_name: [
          {required: true, message: '请输入', trigger: 'blur'}
        ],
      },
    }
  },
  created() {
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.save()
        }
      });
    },
    async save(){
      let _data = await updateOrganInfo(
        this.row.id,
        this.ruleForm.organ_name,
        this.ruleForm.username,
        this.ruleForm.password,
        this.ruleForm.phone,
      );
      if(_data.code == 200) {
        this.$message.success(_data.message)
        this.$emit('watchState', {
          obj:this.ruleForm
        })
        this.clearContent()
      }else {
        this.$message.error(_data.message)
      }
    },

    clearContent() {
      this.$refs.ruleForm.resetFields()
    },
    cancel() {
      this.$emit('watchState', false)
    }
  },
  watch: {
    dialog(){
      if(this.dialog){
        this.ruleForm = this.row
      }
    }
  }
}
</script>

<style scoped lang="scss">

</style>
